<template>
  <div class="card-content">
    <div class="card-content-item">
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
      </div>   
    </div>
    <div class="card-content-item">
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
      </div>   
    </div>
    <div class="card-content-item">
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
      </div>   
    </div>
    <div class="card-content-item">
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
      </div>   
    </div>
    <div class="card-content-item">
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
      </div>   
    </div>
  </div>
</template>
<script>
import Skeleton from '@/components/Skeleton/Skeleton';
import { Hr } from '@n11/so-ui-components';

export default {
  name: 'OrdersSkeleton',
  components: {
    Skeleton,
    Hr,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mobiles.scss';
@import '@/assets/styles/mobilesFooter.scss';
@import '@/assets/styles/card.scss';

.hr {
  width: 90%;
  margin: 10px 0;
}
span {
  display: block;
}
strong {
  display: block;
}

.card-content-result {
  margin-top: 8px;
}
</style>
